import classNames from 'classnames'
import { MYSOFIE_MONCOMPTE_URL, MYSOFIE_SITE_URL } from '../../../../utils/consts'
import Svg from '../../../Svg'
import HomeNav from './HomeNav'
import svgDesktopLogo from './svgs/desktop/mysofie.svg'

type ProgressStep = 1 | 2 | 3 | 4

type Props =
  | {
      variant: 'mybooster'
    }
  | {
      variant: 'home'
      step?: ProgressStep
    }

export const WebHeader = (props: Props) => {
  const onLogoClick = () => {
    window.location.assign(MYSOFIE_SITE_URL)
  }

  const onProfileClick = () => {
    window.location.assign(MYSOFIE_MONCOMPTE_URL)
  }

  return (
    <>
      {props.variant === 'home' ? (
        <HomeNav onProfileClick={onProfileClick} onLogoClick={onLogoClick} />
      ) : (
        <>
          <MyBoosterNav onLogoClick={onLogoClick} />
        </>
      )}
    </>
  )
}

const MyBoosterNav = (props: { onLogoClick: () => void }) => {
  return (
    <nav className={classNames('w-full')}>
      {/* Mobile */}
      <div className="sm:hidden flex items-center py-4">
        <Svg alt="Icone mySofie" src={svgDesktopLogo} width={80} height={50} onClick={props.onLogoClick} />
        <div
          className={classNames(
            'ml-3 sm:ml-3 pl-3 sm:pl-8 py-1 border-greyLight border-l-2',
            'text-xs sm:text-base font-medium'
          )}
        >
          myBooster
        </div>
      </div>

      {/* Desktop */}
      <div className="hidden sm:flex space-x-12 px-12 py-6 items-center">
        <div className="w-[300px] flex items-center">
          <Svg
            className="mr-8"
            alt="Icone mySofie"
            src={svgDesktopLogo}
            width={88}
            height={55}
            onClick={props.onLogoClick}
          />
          <div className={classNames('px-8 border-l-2 py-1 border-greyLight text-ms text-[#3F1774]')}>myBooster</div>
        </div>
      </div>
    </nav>
  )
}
